import React from 'react';
import { Route, Switch } from 'react-router-dom';
import QRcode from '../qrcode/QRcode';
import Login from '../authentication/Login';
import TestDrive from '../testdrive/TestDrive';
import TermsAndConditions from '../termsandconditions/TermsAndConditions';
import SubmitStatus from '../submitstatus/SubmitStatus';
import Alert from '../layout/Alert';
import PrivateRoute from '../routing/PrivateRoute';

const Routes = () => {
  return (
    <section className='container'>
      <Alert />
      <Switch>
        <Route exact path='/' component={Login} />
        <PrivateRoute exact path='/QRcode' component={QRcode} />
        <PrivateRoute
          exact
          path='/termsandconditions'
          component={TermsAndConditions}
        />
        <PrivateRoute exact path='/testdrive' component={TestDrive} />
        <PrivateRoute exact path='/submitstatus' component={SubmitStatus} />
      </Switch>
    </section>
  );
};

export default Routes;
